import React, { useEffect, useState } from "react";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import useAuth from "hooks/useAuth";
import "react-phone-number-input/style.css";
import DatePicker from "components/Datepicker/Datepicker";
import MaskReal from "services/formateRS";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import Table from "components/Table/Table.js";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import api from "assets/services/api";
import IconButton from "@material-ui/core/IconButton";
import moment from "moment";
import Checkbox from '@material-ui/core/Checkbox';

const useStyles2 = makeStyles(styles2);

function ModalAddOccurrence(props) {
  console.log("ModalAddOccurrence", props);
  Date.prototype.withoutTime = function () {
    var d = new Date(this);
    d.setHours(0, 0, 0, 0);
    return d;
  };
  const classes2 = useStyles2();

  const { storageId, user } = useAuth();

  const [br, setBR] = useState(false);
  const [description, setDescription] = useState();
  const [returned, setReturned] = useState(false);
  const [date, setDate] = useState((new Date()).withoutTime());
  const [controlSnack, setControlSnack] = useState(false);
  const [occurrenceType, setOccurrenceType] = useState([]);
  const [tittle, setTittle] = useState("");
  const [listProducts, setListProducts] = useState([]);
  const [productId, setProductId] = useState(0);
  const [client, setClient] = useState([]);
  const [clients, setClients] = useState([]);
  const [products, setProducts] = useState([]);
  const [amount, setAmount] = useState(0);
  console.log("tittle", tittle);
  const showNotification = (place) => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
          }, 6000);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (controlSnack) showNotification("br");
  }, [controlSnack]);

  useEffect(() => {
    getOccurrenceType();
    loadClients();
    loadProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function loadProducts() {
    const response = await api.get('/product/admin/' + storageId);
    setProducts(response.data);
    if (response.data.length > 0) {
      setProductId(response.data[0].id);

    };
  };
  async function loadClients() {
    const response = await api.get('/client/sell/' + storageId);
    setClients(response.data);
    if (response.data.length > 0) {
      setClient(response.data[0].id);
    };
  }
  async function handleAddOccurrence(e) {
    e.preventDefault();

    const response = await api.post(`/occurrence/${storageId}`, {
      id_user: user.id,
      tittle: tittle,
      products: listProducts,
      description,
      id_client: client
    });
    if (response.status === 201) {
      props.loadOccurrences();
      props.onHide();
    } else {
      alert("Erro ao adicionar ocorrência");
    }

  }

  async function getOccurrenceType() {
    const response = await api.get(`/occurrence/type/${storageId}?page=1&pageSize=200&search=`);
    if (response.data.occurrences.length > 0) {
      console.log("if api")
      setOccurrenceType(response.data.occurrences);
      setTittle(response.data.occurrences[0].tittle);
    }
  }
  const tableData = () => {
    let teste = [];
    for (let i = 0; i < listProducts.length; i++) {
      teste[i] = [];
      teste[i].push(
        <div className={classes2.tableActions}>
          <Checkbox checked={listProducts[i].returned} disabled inputProps={{ 'aria-label': 'primary checkbox' }} />
        </div>
      );
      teste[i].push(listProducts[i].date_table);
      teste[i].push(listProducts[i].name);
      teste[i].push(listProducts[i].amount);

      teste[i].push(
        <div className={classes2.tableActions}>
          <Tooltip
            id="tooltip-top-start"
            title="Deletar"
            placement="top"
            classes={{ tooltip: classes2.tooltip }}
          >
            <IconButton
              aria-label="Close"
              className={classes2.tableActionButton}
              onClick={() => deleteToList()}
            >
              <Close
                className={
                  classes2.tableActionButtonIcon + " " + classes2.close
                }
              />
            </IconButton>
          </Tooltip>
        </div>
      );
    };
    return teste;
  };

  async function deleteToList(index) {
    let listNew = [...listProducts];
    listNew.splice(index, 1);
    setListProducts(listNew);
  };
  async function addToList(e) {
    e.preventDefault();
    let newItemList = {};

    const verify_prod = listProducts.filter(p => p.id_product == productId);
    if (verify_prod.length > 0) {
      return alert('Produtos já adicionado');
    } else if (amount <= 0) {
      return alert('Quantidade inválida');
    }

    let theProduct;
    const id_product = productId ? parseInt(productId) : products[0].id
    for (let i = 0; i < products.length; i++) {
      if (products[i].id === id_product) {
        theProduct = products[i].name;
        break;
      };
    };



    newItemList = { name: theProduct, amount, id_product, date_table: moment(date).format('DD/MM/YYYY'), date, returned };
    setListProducts(prevList => ([...prevList, newItemList]));
  };
  async function cleanList() {
    let listNew = [];
    setListProducts(listNew);
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Adicionar ocorrencia
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleAddOccurrence}>
        <Modal.Body>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridAlternativeRoute">
              <Form.Label>Titulo</Form.Label>
              <Form.Control
                onChange={(event) => setTittle(event.target.value)}
                value={tittle}
                as="select"
                defaultValue="Choose..."
                required
              >
                {occurrenceType.map((occ) => (
                  <option key={String(occ.id)} value={occ.tittle}>
                    {occ.tittle}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="formGridDescription">
              <Form.Label>Descrição</Form.Label>
              <Form.Control
                onChange={(event) => setDescription(event.target.value)}
                type="text"
                placeholder="Descrição da ocorrência"
                required
              />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="formGridAlternativeRoute">
              <Form.Label>Cliente</Form.Label>
              <Form.Control
                onChange={(event) => setClient(event.target.value)}
                value={client}
                as="select"
                defaultValue="Choose..."
                required
              >
                {clients.map((clt) => (
                  <option key={String(clt.id)} value={clt.id}>
                    {clt.social_reason} - {clt.fantasy_name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridAlternativeRoute">
              <Form.Label>Produto</Form.Label>
              <Form.Control onChange={event => setProductId(event.target.value)} as="select" defaultValue="Choose...">
                {products.map((product, index) => (
                  <option key={String(index)} value={product.id}>{product.name}</option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group as={Col} controlId="formGridDescription">
              <Form.Label>Quantidade</Form.Label>
              <Form.Control
                onChange={(event) => setAmount(event.target.value)}
                type="double"
                placeholder="Quantidade do produto"
                required
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridDate">
              <Form.Label>Data da ocorrencia</Form.Label>
              <div>
                <DatePicker
                  selected={date}
                  onChange={(date) => setDate(date.withoutTime())}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Digite ou clique aqui"
                  disabledKeyboardNavigation
                  required
                />
              </div>
            </Form.Group>
            <Form.Group as={Col} xs={2} controlId="formGridSellsman" >
              <Form.Label>Mercadoria retornou?</Form.Label>
              <div>
                <Checkbox checked={returned} onChange={(e) => setReturned(e.target.checked)} inputProps={{ 'aria-label': 'primary checkbox' }} />
              </div>
            </Form.Group>
          </Form.Row>
          <div className="d-flex justify-content-center">
            <Button color="success" onClick={(e) => (addToList(e))}>
              Adicionar a lista
            </Button>
            <Button color="success" onClick={cleanList}>
              Limpar a lista
            </Button>
          </div>
          {<Form.Row>
            <Table
              tableHeaderColor="danger"
              tableHead={["Retornou", "Data", "Quantidade", "Produto", "Ações"]}
              tableData={tableData()}
            />
          </Form.Row>
          }

        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button color="success" type="submit">
              Adicionar
            </Button>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message="Ocorrencia adicionada com sucesso"
              open={br}
              closeNotification={() => setBR(false)}
              close
            />
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ModalAddOccurrence;
